var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowWorkIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "how-work-icon2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "icon_Background_",
    "data-name": "icon (Background)",
    width: 80,
    height: 80,
    rx: 24,
    fill: "#9757d7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Whistle_Line",
    "data-name": "icons/Whistle/Line",
    transform: "translate(28 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8,16A8,8,0,1,1,8,0h3.311a.5.5,0,0,1,.33.125l.409.36.013.01L12.074.5,14,2,15.926.5l.013-.011.01-.009.409-.36A.5.5,0,0,1,16.689,0H21a3,3,0,0,1,3,3V5.351a3.006,3.006,0,0,1-2.628,2.977l-5.435.68A8.009,8.009,0,0,1,8,16ZM8,2a6,6,0,1,0,5.953,6.759l.194-1.543,6.978-.872A1,1,0,0,0,22,5.351V3a1,1,0,0,0-1-1H17.465A4.013,4.013,0,0,1,14,4a4.013,4.013,0,0,1-3.465-2Z",
    transform: "translate(0 4)",
    fill: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M3,6A3,3,0,1,1,6,3,3,3,0,0,1,3,6ZM3,2A1,1,0,1,0,4,3,1,1,0,0,0,3,2Z",
    transform: "translate(5 9)",
    fill: "#fcfcfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowWorkIcon2);
export default __webpack_public_path__ + "static/media/how-work-icon2.966641b283afcc59a3e99d6fbcfaec6b.svg";
export { ForwardRef as ReactComponent };